exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{padding:0;margin:0}#app,body,html{height:100%}.el-dialog__header{background-color:#303133;padding-bottom:15px!important}.el-dialog__title{color:#fff}.el-dialog__body{padding-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-723b4fad","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 985
// module chunks = 265